import { AccessPointLogDto } from '../models/AccessPointLogDto';
import { BaseService } from './BaseService';
import { AxiosResponse, type RawAxiosRequestConfig } from 'axios';
import { resources } from '../resources';
import { Page } from '../models/common/Page';

export class AccessPointLogService extends BaseService {
  public async getAccessPointLogs(args?: Record<string, any>, options: RawAxiosRequestConfig = {}): Promise<AxiosResponse<Page<AccessPointLogDto>>> {
    return this.get<Page<AccessPointLogDto>>(
      resources.getAccessPointLogs,
      {
        ...args,
      },
      options
    );
  }
}
